import { Layout } from 'antd';
import { Route, Routes } from 'react-router-dom';
import '../../App.css';
import HeaderPeche from '../../shared/components/headerPeche.component';
import Accueil from '../accueil/accueil.page';
import Connexion from '../connexion/connexion.page';
import CreationCompte from '../creationcompte/creationcompte.page';
import EspaceUser from '../espaceuser/espaceuser.page';
import FooterPeche from '../../shared/components/footerPeche.component';
import Reservation from '../reservation/reservation.page';
import Planning from '../planning/planning.page';
import ListeReservations from '../reservation/listereservation.page';
import PlanningAdmin from '../planning/planningadmin.page';
import ListeUsers from '../listeuser/listeusers.page';
import ReservationAdmin from '../reservation/reservationAdmin.page';
import ForgetPassword from '../forgetpassword/forgetpassword.page';
import NewForgetPassword from '../forgetpassword/newforgetpassword.page';

const { Content } = Layout;

function MainLayout() {

    return (
        <Layout className="main-layout">
            <HeaderPeche />
            <Content className="outer-content">
                <Content className="inner-content">
                    <Routes>
                        <Route path="/" element={<Accueil />} />
                        <Route path="/connexion" element={<Connexion />} />
                        <Route path="/creationcompte" element={<CreationCompte />} />
                        <Route path="/espaceuser" element={<EspaceUser />} />
                        <Route path="/reservation" element={<Reservation />} />
                        <Route path="/reservationadmin" element={<ReservationAdmin />} />
                        <Route path="/planning" element={<Planning />} />
                        <Route path="/planningadmin" element={<PlanningAdmin />} />
                        <Route path="/listereservations" element={<ListeReservations />}/>
                        <Route path="/listeusers" element={<ListeUsers />} />
                        <Route path="/forgetpassword" element={<ForgetPassword />} />
                        <Route path="resetpassword" element={<NewForgetPassword />} />
                        <Route path="*" element={<h2>Page non trouvée 😢</h2>} />
                    </Routes>
                </Content>
            </Content>
            <FooterPeche />
        </Layout>
    );
}

export default MainLayout;
